import { FiltersExpression, Operation, Operator } from "types";
import { InternalResourceConfig } from "./types";

export function getNestedValue(obj: unknown, path: string): unknown {
  if (!obj || typeof obj !== "object") return undefined;

  const keys = path.split(".");
  let value: unknown = obj;

  for (const key of keys) {
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "object") return undefined;
    value = (value as Record<string, unknown>)[key];
  }

  return value;
}

export function buildGraphQLFilters(
  config: InternalResourceConfig,
  urlFilters: Record<string, string>,
): FiltersExpression | undefined {
  const search = urlFilters.search?.trim();
  if (!search) return undefined;

  const searchFields = config.list.searchFields;
  if (searchFields.length === 0) return undefined;

  const isUuid =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
      search,
    );

  const filters = searchFields
    .map((entry) =>
      typeof entry === "string" ? { field: entry, op: Operation.Ilike } : entry,
    )
    .filter((entry) => isUuid || !entry.field.endsWith(".id"))
    .map((fieldConfig) => {
      return {
        op: fieldConfig.op,
        field: fieldConfig.field,
        values: [search],
      };
    });

  if (filters.length === 0) return undefined;

  if (filters.length === 1) {
    return {
      operator: Operator.And,
      filters,
      childExpressions: [],
    };
  }

  return {
    operator: Operator.Or,
    filters,
    childExpressions: [],
  };
}
